// import styles from './SignIn.module.scss';
import Field from 'components/elements/Field/field'
import { Link, useNavigate } from "react-router-dom";
import './SignIn.css';
import SimpleReactValidator from 'simple-react-validator';
import { useEffect, useRef, useState } from 'react';
import Loader from 'components/elements/Loader/Loader';
import { getData, setUser, postFormData, getRestData, setOnboarding } from 'utils/service';
import { toast } from "react-toastify";
import { browserName, browserVersion, osName, osVersion } from "react-device-detect";
import FingerprintJS from '@fingerprintjs/fingerprintjs';


const SignIn = () => {
  const [fingerprint, setFingerprint] = useState('');
  const [, forceUpdate] = useState("");
  const [loading, setLoading] = useState(false);
  const [deviceData, setDeviceData] = useState({ IPv4: '', device_name: '', modal_no: '', browser_info: '', os_version: '' });
  const [formData, SetFormData] = useState({
    username: "",
    password: ""
  });
  useEffect(() => {
    FingerprintJS.load().then(fp => {
      fp.get().then(result => {
        setFingerprint(result.visitorId);
      });
    });
  }, []);
  const handleChange = (e: any) => {
    SetFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const validator = useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );

  useEffect(() => {
    getData()
  }, [])
  const getData = async () => {
    let res: any = await getRestData('https://api.ipify.org?format=json')
    setDeviceData({ IPv4: res.ip, device_name: osName, modal_no: osVersion, browser_info: browserName + ' ' + browserVersion, os_version: osVersion })
    // setIP(res.data.IPv4)
  }
  const handleFormSubmit = async (e: any) => {
    e.preventDefault();
    const formValid = validator.current.allValid();
    if (formValid) {
      setLoading(true)
      let params: any = {
        email_cell: formData.username,
        pwd: formData.password,
        ip: deviceData.IPv4,
        device_name: deviceData.device_name,
        modal_no: deviceData.modal_no,
        os_version: deviceData.os_version,
        browser_info: deviceData.browser_info,
        device_type: 'web',
        imei: fingerprint
      }
      let response: any = await postFormData('login', params)
      if (response.success == "true") {
        let data = {
          device_id: response.device_id,
          exam_type_id: response.exam_type_id,
          flag: response.flag,
          is_mobile_verify: response.is_mobile_verify,
          token: response.token,
          first_name: response.first_name,
          last_name: response.last_name,
          mobile: response.mobile,
          email: response.email,
          group_id: response.group_id,
          subject_id: response.subject_id,
          is_verified: response.is_verified
        }
        setLoading(false)
        let redirect = '';
        let canProcess = true;
        if(!response.exam_type_id || response.exam_type_id === ''){
          redirect = 'exam-type';
        }else if(!response.group_id || response.group_id === ''){
          redirect = 'select-group';
        }else if(!response.subject_id || response.subject_id === ''){
          redirect = 'select-subject';
        }else if(response.is_verified === '1'){
          redirect = 'dashboard';
        }else if(response.is_verified === '0'){
          canProcess = false;
        }
        if(canProcess){
          if(redirect !== 'dashboard'){
            const onboardingData = {
              ...response,
              path: redirect,
            };
            setOnboarding(onboardingData);
          }
          toast.success(response.message)
          setUser(data)
          window.location.href = redirect;
        }else{
          toast.warning("Your account is not active by Admin. Please wait for admin approval or contact support.")
        }
        
      } else {
        setLoading(false)
        toast.error(response.message)
      }
    } else {
      validator.current.showMessages();
    }
  }
  return (
    <div className="login-container">
      {loading && <Loader />}
      <div className="d-flex justify-content-center h-100">
        <div className="card">
          <div className="card-header">
            <h3>Sign In</h3>
            {/* <div className="d-flex justify-content-end social_icon">
					<span><i className="fab fa-facebook-square"></i></span>
					<span><i className="fab fa-google-plus-square"></i></span>
					<span><i className="fab fa-twitter-square"></i></span>
				</div> */}
          </div>
          <div className="card-body">
            <form onSubmit={(e) => handleFormSubmit(e)}>
              <div className="row">
                <div className="col-8 offset-2">
                  <div className="input-group form-group mb-3 d-flex ">
                    <div className="d-flex w-100">
                      <div className="input-group-prepend">
                        <span className="input-group-text"><i className="fas fa-mobile"></i>+91</span>
                      </div>
                      <input type="text" name="username" value={formData.username} onChange={(e) => handleChange(e)} className="form-control" placeholder="Mobile number 10 Digit" />
                    </div>

                    {validator.current.message(
                      "username",
                      formData.username,
                      "required|phone|10",
                      { className: "text-danger" }
                    )}
                  </div>
                  <div className="input-group form-group mb-3 d-flex">
                    <div className="d-flex w-100">
                      <div className="input-group-prepend">
                        <span className="input-group-text"><i className="fas fa-key"></i></span>
                      </div>
                      <input type="password" name="password" value={formData.password} onChange={(e) => handleChange(e)} className="form-control" placeholder="Password" />
                    </div>

                    {validator.current.message(
                      "password",
                      formData.password,
                      "required|min:1|max:50",
                      { className: "text-danger" }
                    )}
                  </div>
                  {/* <div className="row align-items-center remember mb-3">
                <input type="checkbox" />Remember Me
              </div> */}
                  <div className="form-group">
                    <input type="submit" value="Login" className="btn float-right login_btn" />
                  </div>
                </div>
              </div>

            </form>
          </div>
          <div className="card-footer">
            <div className="d-flex justify-content-center links">
              Don't have an account?<Link to="/signup">Sign Up</Link>
            </div>
            {/* <div className="d-flex justify-content-center">
              <a href="#">Forgot your password?</a>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}
// const SignIn = () => (
//   <div>
//     <form>
//         <Field
//           name="email"
//           type="email"
//           autoComplete="email"
//           required
//           label="Email"
//         />
//         <Field
//           name="password"
//           type="password"
//           autoComplete="password"
//           required
//           label="Password"
//         />
//         <button type="submit">Sign in</button> or{' '}
//         <Link to="/auth/signup">
//           <a>Sign up</a>
//         </Link>
//     </form>
//   </div>
// );

export default SignIn;
